import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import gettext from '@/i18n/gettext';

dayjs.extend(timezone);
dayjs.extend(utc);

/**
 * Returns the correct date format for the currently selected language
 */
function getI18nDateFormatStr() {
  if (gettext.current === 'en') {
    // default for USA
    return 'MM-DD-YYYY';
  }
  if (['cn', 'kr', 'ir'].includes(gettext.current)) {
    // default for China, Korea, Iran
    return 'YYYY-MM-DD';
  }
  // default for majority for world's countries
  return 'DD.MM.YYYY';
}

/**
 * Formats a given date in the correct date format for the currently selected language
 * @param date The date string or epoch to format
 * @param includeTime Whether to include the time or not
 * @return the correctly formatted date for the currently selected language
 */
export default function formatDate(
  date: string | number | Date,
  includeTime = false,
) {
  let formatString = getI18nDateFormatStr();
  if (includeTime) {
    formatString += ' HH:mm:ss';
  }
  const formattedDate = dayjs
    .utc(date)
    .tz(Intl.DateTimeFormat().resolvedOptions().timeZone);
  return formattedDate.format(formatString);
}
